// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './signup-api';

export const useRegister: typeof hookExports.useRegister = hookExports.useRegister;
export const useLogin: typeof hookExports.useLogin = hookExports.useLogin;
export const useLogout: typeof hookExports.useLogout = hookExports.useLogout;
export const useRevokeTokens: typeof hookExports.useRevokeTokens = hookExports.useRevokeTokens;
export const useRefreshToken: typeof hookExports.useRefreshToken = hookExports.useRefreshToken;
export const useConfirmEmail: typeof hookExports.useConfirmEmail = hookExports.useConfirmEmail;
export const useResendConfirmationEmail: typeof hookExports.useResendConfirmationEmail =
  hookExports.useResendConfirmationEmail;
export const useGenerateMfaQr: typeof hookExports.useGenerateMfaQr = hookExports.useGenerateMfaQr;
export const useVerifyMfa: typeof hookExports.useVerifyMfa = hookExports.useVerifyMfa;
export const useAuthenticateMfa: typeof hookExports.useAuthenticateMfa =
  hookExports.useAuthenticateMfa;
export const useResetMfa: typeof hookExports.useResetMfa = hookExports.useResetMfa;
export const useRecoverMfa: typeof hookExports.useRecoverMfa = hookExports.useRecoverMfa;
export const useRequestPasswordReset: typeof hookExports.useRequestPasswordReset =
  hookExports.useRequestPasswordReset;
export const useResetPassword: typeof hookExports.useResetPassword = hookExports.useResetPassword;
export const useGetPasswordResetSession: typeof hookExports.useGetPasswordResetSession =
  hookExports.useGetPasswordResetSession;
export const useLazyGetPasswordResetSession: typeof hookExports.useLazyGetPasswordResetSession =
  hookExports.useLazyGetPasswordResetSession;
export const useVerifyPasswordResetEmail: typeof hookExports.useVerifyPasswordResetEmail =
  hookExports.useVerifyPasswordResetEmail;
export const useVerifyPasswordReset2fa: typeof hookExports.useVerifyPasswordReset2fa =
  hookExports.useVerifyPasswordReset2fa;
export const useVerifyPasswordResetRecoveryCode: typeof hookExports.useVerifyPasswordResetRecoveryCode =
  hookExports.useVerifyPasswordResetRecoveryCode;
